// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/lines-background.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.not-found-container {
  display: flex;
  font-family: "Proxima Nova", sans-serif;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: left;
  -webkit-user-select: none;
          user-select: none;
  animation: fadeIn 2s;
}
.not-found-container .not-found-graphic {
  position: absolute;
  bottom: 0;
  right: 0;
}
.not-found-container p, .not-found-container h1 {
  margin: 0;
}
.not-found-container .not-found-info {
  margin-left: 140px;
  align-self: center;
}
.not-found-container .not-found-info .capsule {
  font-size: 16px;
  text-align: center;
  font-weight: 700;
  color: white;
  background: #4D4D4D;
  border: 1px solid #707070;
  border-radius: 33px;
  width: 201px;
  padding: 20px 0;
}
.not-found-container .not-found-info .jumbotron {
  font-size: 72px;
  font-weight: 700;
  color: #4D4D4D;
}
.not-found-container .not-found-info .subtext {
  font-size: 24px;
  font-weight: 500;
  color: #9F9F9F;
  line-height: 29px;
}
@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .not-found-container .not-found-graphic {
    display: none;
  }
  .not-found-container .not-found-info {
    margin-left: 40px;
    margin-right: 40px;
  }
  .not-found-container .not-found-info .jumbotron {
    font-size: 50px;
  }
  .not-found-container .not-found-info .subtext {
    font-size: 18px;
  }
}
@media (min-width: 768px) and (max-width: 1024px), (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .not-found-container .not-found-graphic {
    display: none;
  }
  .not-found-container .not-found-info {
    margin-left: 40px;
    margin-right: 40px;
  }
  .not-found-container .not-found-info .jumbotron {
    font-size: 50px;
  }
  .not-found-container .not-found-info .subtext {
    font-size: 18px;
  }
}
@media (width: 1024px) and (max-height: 833px) {
  .not-found-container .not-found-graphic {
    display: none;
  }
}
@media (max-width: 1440px) and (max-height: 833px) {
  .not-found-container .not-found-graphic {
    height: 75vh;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/NotFound/notFound.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,uCAAA;EACA,yDAAA;EACA,4BAAA;EACA,yBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,oBAAA;AADJ;AAEI;EACI,kBAAA;EACA,SAAA;EACA,QAAA;AAAR;AAEI;EAAQ,SAAA;AACZ;AAAI;EACI,kBAAA;EACA,kBAAA;AAER;AADQ;EACI,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;AAGZ;AADQ;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAGZ;AADQ;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAGZ;AAAI;EACI;IAAO,UAAA;EAGb;EAFM;IAAO,UAAA;EAKb;AACF;;AC/CY;EDgDJ;IACI,aAAA;EAGV;EADM;IACI,iBAAA;IACA,kBAAA;EAGV;EAFU;IACI,eAAA;EAId;EAFU;IACI,eAAA;EAId;AACF;ACxDY;EDyCJ;IACI,aAAA;EAkBV;EAhBM;IACI,iBAAA;IACA,kBAAA;EAkBV;EAjBU;IACI,eAAA;EAmBd;EAjBU;IACI,eAAA;EAmBd;AACF;AChEY;EDoDJ;IACI,aAAA;EAeV;AACF;AC/DY;EDsDJ;IACI,YAAA;EAYV;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\n\n.not-found-container {\n    display: flex;\n    font-family: 'Proxima Nova', sans-serif;                                             \n    background-image: url('../../assets/images/lines-background.svg');\n    background-repeat: no-repeat;\n    background-position: left;\n    user-select: none;\n    animation: fadeIn 2s;\n    .not-found-graphic {\n        position: absolute;\n        bottom: 0;\n        right: 0;\n    }\n    p, h1 { margin: 0 }\n    .not-found-info {\n        margin-left: 140px;\n        align-self: center;\n        .capsule {\n            font-size: 16px;\n            text-align: center;\n            font-weight: 700;\n            color: white;\n            background: #4D4D4D;\n            border: 1px solid #707070;\n            border-radius: 33px;\n            width: 201px;\n            padding: 20px 0;\n        }\n        .jumbotron {\n            font-size: 72px;\n            font-weight: 700;\n            color: #4D4D4D;\n        }\n        .subtext {\n            font-size: 24px;\n            font-weight: 500;\n            color: #9F9F9F;\n            line-height: 29px;\n        }\n    }\n    @keyframes fadein {\n        from { opacity: 0; }\n        to   { opacity: 1; }\n    }\n}\n\n\n@include media(mobile, tablet) {\n    .not-found-container {\n        .not-found-graphic {\n            display: none;\n        }\n        .not-found-info {\n            margin-left: 40px;\n            margin-right: 40px;\n            .jumbotron {\n                font-size: 50px;\n            }\n            .subtext {\n                font-size: 18px;\n            }\n        }\n    }\n}\n\n@include media(nitty-gritt) {\n    .not-found-container {\n        .not-found-graphic {\n            display: none;\n        }\n    }\n}\n\n@include media(small-desktop) {\n    .not-found-container {\n        .not-found-graphic {\n            height: 75vh;\n        }\n    }\n}","@mixin media($keys...) {\r\n    @each $key in $keys {\r\n        @if ($key==mobile) {\r\n            @media (min-width: 481px) and (max-width: 767px),\r\n            (min-width: 320px) and (max-width: 480px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==tablet) {\r\n            @media (min-width: 768px) and (max-width: 1024px),\r\n            (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==nitty-gritt) {\r\n            @media (width: 1024px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==small-desktop) {\r\n            @media (max-width: 1440px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==desktop) {\r\n            @media (min-width: 1024px) and (max-width: 1440px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
